import { render, staticRenderFns } from "./ElectronicBook.vue?vue&type=template&id=05b5c9ee"
import script from "./ElectronicBook.vue?vue&type=script&lang=js"
export * from "./ElectronicBook.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports